const ActionIconButton = ({ icon: Icon, onClick, danger = false, variant = "filled" }) => {
  const styles =
    variant === "outlined"
      ? danger
        ? "border-[#E3E3E3] text-red-400 bg-white hover:bg-red-50"
        : "border-[#E3E3E3] text-primary-500 bg-white hover:bg-primary-50"
      : danger
        ? "border-transparent text-white bg-primary-500 hover:bg-red-500"
        : "border-transparent text-white bg-primary-500 hover:bg-primary-600";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-8 h-8 rounded-full border flex items-center justify-center transition cursor-pointer ${styles}`}
    >
      <Icon className="w-3.5 h-3.5" />
    </button>
  );
};

export default ActionIconButton;
